import { SyntheticEvent } from "react";
import { motion } from "framer-motion";
import swapIcon from "@icons/swap.svg";
import useWindowSize from "@utils/use_window_size";
import Image from "next/image";
import { isMobile } from "@hudson/ui/lib/utils";
import styles from "@styles/Upfront.module.css";

function SwapButton({
  disabled,
  onSwap,
  y,
}: {
  disabled?: boolean;
  onSwap: (e: SyntheticEvent) => void;
  y: number;
}): JSX.Element {
  const [size] = useWindowSize();
  return (
    <motion.div layout className="relative z-10">
      <motion.button
        aria-label="Swap"
        disabled={disabled}
        initial={false}
        style={{
          right: isMobile() ? "3rem" : "-16px",
          y,
          rotate: size < 1080 ? 90 : 0,
        }}
        animate={{
          y,
          rotate: size < 1080 ? 90 : 0,
        }}
        transition={{
          type: "tween",
          ease: "easeOut",
          duration: 0.3,
        }}
        className={`${styles.background} ${styles.buttonHover} ${styles.focusOutline} absolute inline-flex items-center p-1 border-4 border-white rounded-xl z-10 normal:w-9 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        type="button"
        onClick={onSwap}
      >
        <Image alt="swap" src={swapIcon} height={20} width={20} />
      </motion.button>
    </motion.div>
  );
}

export default SwapButton;
